import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

const COAT = "https://customer-assets.emergentagent.com/job_66cda0d4-d07a-4a92-8bdd-b78d3aba21d7/artifacts/xbhowqoo_ephigie-hayti.jpg";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-[#1a1a1a] mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-12 grid md:grid-cols-3 gap-10">
        <div className="flex items-start gap-4">
          <img src={COAT} alt="" className="h-14 w-14 object-contain mix-blend-screen" />
          <div>
            <div className="font-serif text-2xl">Seayisyen</div>
            <div className="overline mt-1">{t("footer.tagline")}</div>
          </div>
        </div>
        <div>
          <div className="overline mb-3">Cohort 2026</div>
          <div className="text-sm text-neutral-400 leading-relaxed">
            12 weeks · live online · Mon–Fri<br />
            Starts June 15, 2026 — 7:30 PM (Haiti time)
          </div>
          <Link
            to="/cohort-info#cohorts"
            data-testid="footer-compare-cohorts"
            className="mt-3 inline-flex items-center gap-1.5 text-sm text-[#d4af37] hover:text-white transition-colors font-condensed tracking-widest uppercase"
          >
            → {t("footer.compareCohorts", "Compare Cohorts")}
          </Link>
        </div>
        <div>
          <div className="overline mb-3">Contact</div>
          <div className="text-sm text-neutral-400 leading-relaxed">
            seayisyen.net<br />
            email@seayisyen.net<br />
            <Link to="/payment-info" data-testid="footer-payment-link" className="text-[#d4af37] hover:underline">
              Payment information →
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-[#141414] py-5">
        <div className="max-w-7xl mx-auto px-5 md:px-10 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-neutral-500">© 2026 Seayisyen. {t("footer.rights")}</div>
          <div className="text-xs text-[#d4af37]/70 font-condensed tracking-widest">LIBERTÉ · ÉGALITÉ · FRATERNITÉ</div>
        </div>
      </div>
    </footer>
  );
}
